"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVR_ACTIONS = exports.REMINDERS = exports.NOTES = exports.CALL = void 0;
exports.CALL = 'CALL';
exports.NOTES = 'NOTES';
exports.REMINDERS = 'REMINDERS';
exports.IVR_ACTIONS = 'IVR ACTIONS';
